import Address from '@/models/list/address';
import { localeFormatDefault } from '@/plugins/date-print';
import { dateFnsFormat } from '@/helpers/dateFns';
import BaseModel from '../base';
import { DEFAULT_PARAMS } from '@/utils/objectsRHandler';
import { apiService } from '@/services/APIService';
import { rHandler } from '@/plugins/RHandler';
import { differenceInDays, isSameDay } from 'date-fns';

export default class EventActivity extends BaseModel {
  constructor(activity = {}, url = '') {
    super(activity, url);
    this.title = activity.title || null;
    this.description = activity.description || null;

    this.addresses = (activity.addresses || []).map((address) => new Address(address));

    this.experts = activity.experts || [];
    this.images = activity.images || [];
    this.documents = activity.documents || [];
    this.is_online = activity.is_online || false;

    this.start_at = (activity.start_at && localeFormatDefault(activity.start_at)) || '';
    this.end_at = (activity.end_at && localeFormatDefault(activity.end_at)) || '';

    this.videos = activity.videos || [];
    this.is_favorite = activity?.is_favorite || false;

    this.created_at = activity.created_at || '';

    this.assign = activity.assign || []; // { nomination_id, group_id }[]
  }

  get timePeriod() {
    const start = dateFnsFormat.readableTime(this.start_at);
    const end = dateFnsFormat.readableTime(this.end_at);
    return `${start} - ${end}`;
  }

  get isManyDays() {
    const { start_at, end_at } = this;
    return differenceInDays(start_at, end_at) > 1;
  }

  timePeriodByDay(day) {
    const { start_at, end_at } = this;
    return [
      isSameDay(new Date(start_at), new Date(day)) ? dateFnsFormat.readableTime(start_at) : '00:00',
      '-',
      isSameDay(new Date(end_at), new Date(day)) ? dateFnsFormat.readableTime(end_at) : '23:59',
    ].join(' ');
  }

  attachImages(rParams = DEFAULT_PARAMS) {
    const { data, obs } = rParams;
    return rHandler(
      apiService.post(`${this.url}/${this.id}/attach-images`, data),
      (response) => ({ response }),
      (error) => ({ error }),
      obs,
    );
  }

  attachDocuments(rParams = DEFAULT_PARAMS) {
    const { data, obs } = rParams;
    return rHandler(
      apiService.post(`${this.url}/${this.id}/attach-documents`, data),
      (response) => ({ response }),
      (error) => ({ error }),
      obs,
    );
  }
}
